module.exports = __webpack_public_path__ + "img/ac9.07f21d89.jpg";